/* Desktop (768 px and wider): hide the header while scrolling down,
   bring it back the moment the reader scrolls up. Phones are handled
   by os.js (html.os-head-hidden); this sets html.os-head-away, so the
   two never touch the same class. It never hides near the top of the
   page, nor while search, the "I am a" menu or a sheet is open. */
(function () {
  var D = document, root = D.documentElement;
  var header = D.querySelector(".os-header");
  if (!header || !window.matchMedia || !window.requestAnimationFrame) return;
  var mq = window.matchMedia("(min-width: 768px)");
  var lastY = window.scrollY || 0, down = 0, ticking = false;
  function busy() {
    if (header.classList.contains("is-searching")) return true;
    if (D.body && D.body.classList.contains("os-locked")) return true;
    var menu = header.querySelector("[data-os-menu]");
    if (menu && !menu.hidden) return true;
    var a = D.activeElement;
    if (a && header.contains(a) && a.tagName === "INPUT") return true;
    return false;
  }
  function set(away) {
    if (root.classList.contains("os-head-away") !== away) root.classList.toggle("os-head-away", away);
  }
  function update() {
    ticking = false;
    var y = Math.max(0, window.scrollY || 0), dy = y - lastY;
    lastY = y;
    if (!mq.matches || busy() || y < header.offsetHeight * 2) { down = 0; set(false); return; }
    if (dy < 0) { down = 0; set(false); return; }
    down += dy;
    if (down > 12) set(true);
  }
  window.addEventListener("scroll", function () {
    if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
  }, { passive: true });
  if (mq.addEventListener) mq.addEventListener("change", function () { set(false); });
  header.addEventListener("focusin", function () { set(false); });
})();

/* ── CoffeeOS page: the Moment simulator fits the screen ─────────────
   The simulator used to report its height and have the page scale it,
   with the tallest height it had ever reported kept for good. On a
   phone that was a block taller than the screen, scrolling inside a
   page that also scrolls, and a resize left it at the wrong height.

   Now the page tells the frame how much screen there is, and the frame
   lays itself out to that height: device and reading side by side when
   there is width, device beside the stage buttons with the slider and
   reading under them on a phone. The device grows to whatever room is
   left. Its own height reports go to this script only. */
(function () {
  var D = document;

  /* Runs inside the frame. */
  function inFrame() {
    var R = document.getElementById("mml");
    if (!R) return;
    var sim = R.querySelector(".mm-sim");
    var col = sim && sim.children[1];
    var read = col && col.querySelector(".mm-simread");
    var copy = {};
    try { copy = JSON.parse(document.querySelector("[data-mml-copy]").textContent); } catch (e) {}
    /* Every stage's reading, laid invisibly in the same place, so the
       block is as tall as the longest one and never changes height
       when someone moves between stages. */
    if (col && read && copy.sim && copy.sim.zones) {
      col.classList.add("fx-stack");
      copy.sim.zones.forEach(function (z) {
        var g = read.cloneNode(true);
        g.classList.add("fx-ghost");
        g.setAttribute("aria-hidden", "true");
        var put = function (sel, val, html) {
          var n = g.querySelector(sel);
          if (!n) return;
          n.hidden = !val;
          if (html) n.innerHTML = val || ""; else n.textContent = val || "";
        };
        put("[data-mm-k]", z.hi + " - " + z.lo + " °C");
        put("[data-mm-t]", z.t);
        put("[data-mm-s]", (z.primary || "") + (z.notes ? ", " + z.notes : ""));
        put("[data-mm-b]", z.b, true);
        put("[data-mm-h]", z.h);
        var foot = g.querySelector("[data-mm-foot]");
        if (foot) foot.hidden = !z.h;
        [].forEach.call(g.querySelectorAll("*"), function (n) {
          n.classList.remove("mm-swap");
          [].slice.call(n.attributes).forEach(function (a) {
            if (a.name.indexOf("data-mm-") === 0) n.removeAttribute(a.name);
          });
        });
        col.appendChild(g);
      });
    }
    var fitH = 0, last = 0, queued = false;
    function setD(d) { R.style.setProperty("--fx-d", Math.round(d) + "px"); }
    function tall() { return Math.ceil(R.getBoundingClientRect().height); }
    function layout() {
      queued = false;
      var W = document.documentElement.clientWidth;
      if (!W) return;
      var wide = W >= 620, inner = W - 24, lo, hi;
      R.setAttribute("data-fit", wide ? "wide" : "narrow");
      R.classList.remove("fx-tight");
      if (wide) { lo = 220; hi = Math.min(440, inner * 0.48); }
      else { lo = Math.min(128, inner * 0.4); hi = Math.min(260, inner * 0.56); }
      var limit = fitH > 0 ? fitH : 1e9;
      setD(hi);
      if (tall() > limit) {
        setD(lo);
        if (tall() > limit && !wide) R.classList.add("fx-tight");
        if (tall() <= limit) {
          var a = lo, b = hi;
          for (var i = 0; i < 10; i++) {
            var m = (a + b) / 2;
            setD(m);
            if (tall() <= limit) a = m; else b = m;
          }
          setD(a);
        }
      }
      var h = tall();
      if (Math.abs(h - last) >= 1) {
        last = h;
        try { parent.postMessage({ os: "mm-fit-h", px: h }, "*"); } catch (e) {}
      }
    }
    /* a timer, not an animation frame: a frame below the fold gets no
       animation frames, and it has to be the right height before it
       is scrolled to */
    function queue() { if (!queued) { queued = true; setTimeout(layout, 16); } }
    window.addEventListener("message", function (e) {
      var d = e.data;
      if (!d || d.os !== "mm-fit") return;
      fitH = +d.h || 0;
      queue();
    });
    window.addEventListener("resize", queue);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(queue);
    window.addEventListener("load", queue);
    layout();
    try { parent.postMessage({ os: "mm-fit-ready" }, "*"); } catch (e) {}
  }

  var FIT_CSS =
    "html,body{overflow:hidden!important;height:auto!important}" +
    "#mml{padding:12px!important}" +
    "#mml .fx-stack{display:grid}" +
    "#mml .fx-stack>*{grid-area:1/1;min-width:0;align-self:start}" +
    "#mml .fx-ghost{visibility:hidden;pointer-events:none}" +
    "#mml[data-fit] .mm-step{height:46px;padding:0 13px}" +
    "#mml[data-fit] .mm-step b{display:none}" +
    "#mml[data-fit] .mm-dev{width:var(--fx-d);max-width:none}" +
    "#mml[data-fit=wide] .mm-sim{grid-template-columns:var(--fx-d) minmax(0,1fr);align-items:center;" +
      "gap:clamp(20px,3vw,40px);max-width:920px;margin:0 auto}" +
    "#mml[data-fit=wide] .mm-ctl{margin-top:18px}" +
    "#mml[data-fit=wide] .mm-zonebar{margin-top:12px}" +
    "#mml[data-fit=wide] .mm-play{margin-top:12px}" +
    "#mml[data-fit=wide] .mm-simread{border-top:0;border-left:2px solid var(--mm-zone);padding-top:0;" +
      "padding-left:clamp(16px,2vw,24px)}" +
    "#mml[data-fit=narrow] .mm-sim{grid-template-columns:minmax(0,1fr);gap:14px}" +
    "#mml[data-fit=narrow] .mm-sim>div:first-child{display:grid;grid-template-columns:var(--fx-d) minmax(0,1fr);" +
      "grid-template-rows:1fr auto auto;grid-template-areas:'dev zones' 'dev play' 'ctl ctl';column-gap:12px;row-gap:8px}" +
    "#mml[data-fit=narrow] .mm-dev{grid-area:dev;margin:0;align-self:center;border-radius:16px}" +
    "#mml[data-fit=narrow] .mm-zonebar{grid-area:zones;flex-direction:column;flex-wrap:nowrap;margin:0;gap:6px}" +
    "#mml[data-fit=narrow] .mm-zoneb{flex:1 1 0;text-align:left;padding:7px 12px;border-radius:12px}" +
    "#mml[data-fit=narrow] .mm-play{grid-area:play;margin:0;width:100%;justify-content:center;text-align:center;padding:8px 12px}" +
    "#mml[data-fit=narrow] .mm-ctl{grid-area:ctl;margin:4px 0 0}" +
    "#mml[data-fit=narrow] .mm-scale{display:none}" +
    "#mml[data-fit=narrow] .mm-read-k,#mml[data-fit=narrow] .mm-read-s{display:none!important}" +
    "#mml[data-fit=narrow] .mm-simread{padding-top:14px}" +
    "#mml[data-fit=narrow] h3.mm-h3{font-size:18px;margin-bottom:8px}" +
    "#mml[data-fit=narrow] .mm-rte p{font-size:14.5px;line-height:1.55}" +
    "#mml[data-fit=narrow] .mm-foot{margin-top:12px;padding-top:10px;font-size:13px}" +
    "#mml.fx-tight .mm-foot{display:none!important}";

  function patch(html) {
    if (typeof html !== "string" || html.indexOf('id="mml"') < 0 || html.indexOf("mm-fit") > -1) return html;
    html = html.replace(/<\/head>/i, "<style>" + FIT_CSS + "</style></head>");
    var at = html.lastIndexOf("</body>");
    var js = "<script>/*mm-fit*/(" + inFrame.toString() + ")();<\/script>";
    return at < 0 ? html + js : html.slice(0, at) + js + html.slice(at);
  }

  /* The simulator's HTML is rewritten on its way to the frame. */
  var bag = window.OS_SIM || {};
  var held = bag.moment;
  try {
    Object.defineProperty(bag, "moment", {
      configurable: true, enumerable: true,
      get: function () { return held; },
      set: function (v) { held = patch(v); }
    });
    if (held) held = patch(held);
    window.OS_SIM = bag;
  } catch (e) {}

  function frames() { return D.querySelectorAll('[data-os-frame="sim"][data-sim="moment"] iframe'); }
  function frameOf(win) {
    var fs = frames();
    for (var i = 0; i < fs.length; i++) if (fs[i].contentWindow === win) return fs[i];
    return null;
  }
  /* Screen height left for the frame: the window, less the header and
     any bar fixed to the bottom of a phone, less a margin. */
  function room() {
    var vh = window.innerHeight, top = 0, bot = 0;
    var hd = D.querySelector(".os-header");
    if (hd) {
      var pos = getComputedStyle(hd).position;
      if (pos === "fixed" || pos === "sticky") top = hd.getBoundingClientRect().height;
    }
    if (D.elementsFromPoint) {
      var hit = D.elementsFromPoint(window.innerWidth / 2, vh - 2);
      for (var i = 0; i < hit.length && !bot; i++) {
        for (var n = hit[i]; n && n.nodeType === 1 && n !== D.body; n = n.parentElement) {
          if (getComputedStyle(n).position !== "fixed") continue;
          var r = n.getBoundingClientRect();
          if (r.height > 0 && r.height < 120 && r.top > vh / 2) bot = vh - r.top;
          break;
        }
      }
    }
    return Math.max(380, Math.round(vh - top - bot - 24));
  }
  function send(f) {
    try { f.contentWindow.postMessage({ os: "mm-fit", h: room() }, "*"); } catch (e) {}
  }
  function prep(f) {
    f.setAttribute("scrolling", "no");
    f.style.transform = "";
    f.style.width = "100%";
    var box = f.closest(".os-fr");
    if (box) box.style.width = "";
    var scr = f.closest(".os-fr__screen");
    if (scr) scr.style.aspectRatio = "auto";
  }
  function size(f, px) {
    if (!(px > 80)) return;
    var scr = f.closest(".os-fr__screen");
    if (scr) scr.style.height = px + "px";
    f.style.height = px + "px";
  }
  window.addEventListener("message", function (e) {
    var d = e.data;
    if (!d || typeof d !== "object") return;
    if (d.os !== "sim-height" && d.os !== "mm-fit-h" && d.os !== "mm-fit-ready") return;
    var f = frameOf(e.source);
    if (!f) return;
    if (d.os === "sim-height") { e.stopImmediatePropagation(); return; }
    if (d.os === "mm-fit-ready") { prep(f); send(f); return; }
    prep(f);
    size(f, +d.px);
  }, true);
  var t = null;
  window.addEventListener("resize", function () {
    clearTimeout(t);
    t = setTimeout(function () { [].forEach.call(frames(), send); }, 120);
  });
})();

/* ── Product cards: the percentage off goes on the Sale flag ─────────
   Both prices on a card are printed by the same money format, so their
   digits compare directly whatever the currency. */
(function () {
  var D = document;
  function num(s) { var d = String(s || "").replace(/[^\d]/g, ""); return d ? parseInt(d, 10) : 0; }
  function run() {
    [].forEach.call(D.querySelectorAll(".os-p .os-p__flag--sale"), function (flag) {
      var card = flag.closest(".os-p");
      if (!card) return;
      card.classList.add("rsx-sale");
      if (flag.querySelector(".os-p__pct")) return;
      var foot = card.querySelector(".os-p__foot");
      if (!foot) return;
      var bs = foot.querySelectorAll("b"), now = 0, was = 0;
      for (var i = 0; i < bs.length; i++) {
        if (bs[i].closest("[hidden]")) continue;
        var s = bs[i].nextElementSibling;
        if (!s || s.tagName !== "S") continue;
        now = num(bs[i].textContent); was = num(s.textContent);
        break;
      }
      if (!(now > 0 && was > now)) return;
      var pct = Math.round((1 - now / was) * 100);
      if (pct < 1) return;
      var sp = D.createElement("span");
      sp.className = "os-p__pct";
      sp.textContent = "\u2212" + pct + "%";
      flag.appendChild(sp);
    });
  }
  var t = null;
  function soon() { clearTimeout(t); t = setTimeout(run, 60); }
  function start() {
    run();
    if (!D.querySelector(".os-p")) return;
    if ("MutationObserver" in window && D.body) {
      new MutationObserver(function (ms) {
        for (var i = 0; i < ms.length; i++) if (ms[i].addedNodes.length) { soon(); return; }
      }).observe(D.body, { childList: true, subtree: true });
    }
  }
  if (D.readyState === "loading") D.addEventListener("DOMContentLoaded", start);
  else start();
})();
